import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

export const initialState = {
  isOpened: false,
  isConfirmed: false,
  isDeclined: false,
  title: 'Fill Empty PO#',
  inputLabel: 'PO Number',
  inputValue: '',
  selectedPurchaseScenarios: [],
  vendorOptions: [],
  selectedVendors: [],
}

const fillPONumberModalSlice = createSlice({
  name: 'fillPONumberModal',
  initialState,
  reducers: {
    open: (state, { payload }) => {
      state.isOpened = true
      state.isConfirmed = false
      state.isDeclined = false
      state.inputValue = ''
      state.selectedPurchaseScenarios = []
      state.vendorOptions = Array.isArray(payload?.vendorOptions) ? payload.vendorOptions : []
      state.selectedVendors = []

      if (payload?.title && payload.title !== '') {
        state.title = payload.title
      }
      if (payload?.inputLabel && payload.inputLabel !== '') {
        state.inputLabel = payload.inputLabel
      }
    },
    confirm: (state, { payload }) => {
      state.isConfirmed = true
      state.isOpened = false
      if (payload && typeof payload === 'object') {
        state.inputValue = payload.inputValue ?? ''
        state.selectedPurchaseScenarios = Array.isArray(payload.selectedPurchaseScenarios)
          ? payload.selectedPurchaseScenarios
          : []
        state.selectedVendors = Array.isArray(payload.selectedVendors) ? payload.selectedVendors : []
      } else {
        state.inputValue = payload ?? ''
        state.selectedPurchaseScenarios = []
        state.selectedVendors = []
      }
    },
    decline: (state) => {
      state.isDeclined = true
      state.isOpened = false
    },
  },
})

export const fillPONumberModalActions = fillPONumberModalSlice.actions

export const fillPONumberModalThunkActions = {
  open: createAsyncThunk('fillPONumberModal/open', async (payload, { extra, dispatch }) => {
    const store = extra.store

    dispatch(fillPONumberModalActions.open(payload))

    return new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const state = store.getState()
        const modalState = state.fillPONumberModal

        if (modalState.isConfirmed) {
          unsubscribe()
          resolve({
            isConfirmed: true,
            inputValue: modalState.inputValue ?? '',
            selectedPurchaseScenarios: modalState.selectedPurchaseScenarios ?? [],
            selectedVendors: modalState.selectedVendors ?? [],
          })
        }

        if (modalState.isDeclined) {
          unsubscribe()
          resolve({ isConfirmed: false })
        }
      })
    })
  }),
}

export default fillPONumberModalSlice.reducer

export const useFillPONumberModalManagement = () => {
  const dispatch = useDispatch()
  const { isOpened, title, inputLabel, vendorOptions } = useSelector((state) => state.fillPONumberModal)

  const open = async ({ title, inputLabel, vendorOptions } = {}) => {
    const { payload } = await dispatch(fillPONumberModalThunkActions.open({ title, inputLabel, vendorOptions }))
    return payload
  }

  const confirm = (data) => {
    return dispatch(fillPONumberModalActions.confirm(data))
  }

  const decline = () => {
    return dispatch(fillPONumberModalActions.decline())
  }

  return {
    isOpened,
    title,
    inputLabel,
    vendorOptions,
    open,
    confirm,
    decline,
  }
}
